import Vue from "vue";

// Common
//Vue.component('pagination', require('./Common/Pagination').default);

// Search
Vue.component('form-search-header', require('./Search/FormHeader').default);
Vue.component('popup-search-results', require('./../popups/SearchResults').default);

// Newsletter
Vue.component('form-newsletter', require('./Newsletter/Form').default);

// Contact
Vue.component('form-contact', require('./Contact/Form').default);

// Support
Vue.component('form-support', require('./Support/Form').default);

// Auth
Vue.component('form-login', require('./Auth/FormLogin').default);
Vue.component('form-forgot-password', require('./Auth/ForgotPassword').default);
Vue.component('form-request-access', require('./Auth/FormRequestAccess').default);
Vue.component('form-registration', require('./Auth/FormRegistration').default);
Vue.component('form-reset-password', require('./Auth/ResetPassword').default);
Vue.component('form-reactivation', require('./Auth/FormReactivation').default);
